import { axios } from '../utilities/axios';

const endpoint = `${process.env.CVNA_APP_KONG_URL}/core/user-notifications/api/v1/`;
export default class UserNotificationsApi {
  static getUserNotifications() {
    return axios.get(`${endpoint}notifications`).then(response => response.data);
  }

  static dismissUserNotification(notificationId) {
    return axios.post(`${endpoint}notifications/dismiss/${notificationId}`).then(response => response.data);
  }
}
